module.exports = __webpack_public_path__ + "static/media/feature-tile-icon-03.9e5b9def.svg";